
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.218 6.863a3.667 3.667 0 010 7.333M10.44 6.863v13.444a1.222 1.222 0 01-1.223 1.222H7.995a1.222 1.222 0 01-1.223-1.222v-6.111","stroke":"#0B30B2","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.884 6.863l5.53-4.608a1.1 1.1 0 011.803.846v14.857a1.1 1.1 0 01-1.804.846l-5.53-4.608H3.107a1.222 1.222 0 01-1.222-1.222v-4.89a1.222 1.222 0 011.222-1.221h9.778","stroke":"#0B30B2","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    